import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

export enum EAutomationsRoute {
  automations = 'automations',
  list = 'list',
  view = 'view',
}

export const automationMenuRoutes = {
  key: EAutomationsRoute.automations,
  url: 'automations',
  children: [
    {
      key: EAutomationsRoute.list,
      url: 'list',
    },
    {
      key: EAutomationsRoute.view,
      url: 'view/:id',
    },
  ],
};

export const automationsRoutes = (scope: string): Routes => [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([scope, EAutomationsRoute.automations, EAutomationsRoute.list]),
    pathMatch: 'full',
  },
  {
    path: CamRoutes.getUrl([scope, EAutomationsRoute.automations, EAutomationsRoute.list]),
    loadComponent: () => import('./pages/list/automations.component').then(c => c.AutomationsPage),
  },
  {
    path: CamRoutes.getUrl([scope, EAutomationsRoute.automations, EAutomationsRoute.view]),
    loadComponent: () => import('./pages/view/automation-view.component').then(c => c.AutomationViewPage),
  },
];
